import {
  SR_API_ACTION_HOUSEHOLD_LISTING_GET_BY_ID,
} from 'api/actionTypes';

export default async function getById({ state, apiClient }, { householdListingId }) {
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_LISTING_GET_BY_ID,
    state: state,
    payload: {
      householdListingId,
    },
    onSuccess(householdListing) {
      state.set(['householdListing'], householdListing);
      return householdListing;
    },
  });
}
